"use strict";

exports.__esModule = true;
exports.unstable_batchedUpdates = void 0;

var _reactDom = require("react-dom");

exports.unstable_batchedUpdates = _reactDom.unstable_batchedUpdates;


//////////////////
// WEBPACK FOOTER
// ./~/react-redux/lib/utils/reactBatchedUpdates.js
// module id = 1963
// module chunks = 0